import { API } from '@/api'
import { browserEnv } from '@/defines/environment'

export const wxjssdkInit = async () => {
  if (browserEnv === 'weixin') {
    try {
      const {
        appId,
        nonceStr,
        signature,
        timestamp
      } = await API.wechat.getWechatConfig()
      if (window.wx) {
        window.wx.config({
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: ['getLocation']
        })
      }
    } catch (error) {}
  }
}
